export const CLOSE_SIDEBAR_WIDTH = 56;
export const OPEN_SIDEBAR_WIDTH = 250;
export const USER_OFFER_TERMS_TYPE = 'ESD_OFFER_TERMS';
export const ORDERS_OPEN_PATH = '/orders/open?status=ACTIVE';
export const ORDERS_HISTORY_PATH = '/orders/history?status=HISTORY';
export const ORDERS_PATH = '/orders';
